import { render, staticRenderFns } from "./SubscriptionProfile.vue?vue&type=template&id=ff0b0226"
import script from "./SubscriptionProfile.vue?vue&type=script&lang=js"
export * from "./SubscriptionProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports